
import i18n from "@/lib/i18n";

/**
 * Distances for putting tests
 */

export const getPuttingTestDistances = (testId: string): Record<string, string> => {
  // Check the current path to determine the level
  const pathname = window.location.pathname;
  const isLevel1 = pathname.includes('level1');
  const isLevel2 = pathname.includes('level2');
  const isLevel3 = !isLevel1 && !isLevel2;
  
  if (isLevel3) {
    if (testId === "putts-plat") {
      return {
        "A": "0,5m",
        "B": "0,8m",
        "C": "1m"
      };
    } else if (testId === "putts-montee") {
      const uphill = i18n.t('distances.uphill', { ns: 'training' });
      return {
        "A1": `0,5m (${uphill})`,
        "B1": `0,8m (${uphill})`,
        "C1": `1m (${uphill})`
      };
    } else if (testId === "putts-descente") {
      const downhill = i18n.t('distances.downhill', { ns: 'training' });
      return {
        "A2": `0,5m (${downhill})`,
        "B2": `0,8m (${downhill})`,
        "C2": `1m (${downhill})`
      };
    } else if (testId === "putts-pente") {
      const leftToRight = i18n.t('distances.leftToRight', { ns: 'training' });
      return {
        "A3": `0,5m (${leftToRight})`,
        "B3": `0,8m (${leftToRight})`,
        "C3": `1m (${leftToRight})`
      };
    } else if (testId === "putts-pente-droite") {
      const rightToLeft = i18n.t('distances.rightToLeft', { ns: 'training' });
      return {
        "A4": `0,5m (${rightToLeft})`,
        "B4": `0,8m (${rightToLeft})`,
        "C4": `1m (${rightToLeft})`
      };
    }
  } else if (isLevel2) {
    // Level 2 distances
    if (testId === "putts-plat") {
      return {
        "D": "1,2m",
        "E": "1,5m",
        "F": "3m"
      };
    }
    // Add other level 2 putting tests if needed
  } else {
    // Level 1 distances
    if (testId === "putts-plat") {
      return {
        "G": "6m",
        "H": "10m",
        "I": "12m"
      };
    }
    // Add other level 1 putting tests if needed
  }
  
  return {};
};
